import React from 'react';
import { Link } from 'react-router-dom';

import Seo from '../ui/Seo';
import Reveal from '../ui/Reveal';
import WordReveal from '../ui/WordReveal';

/* A single-page app answers an unknown URL with the index document and
   HTTP 200, so a wrong address looks like a real page to a crawler. The
   noindex is what keeps those out of the index; the status code cannot
   say it for us. */
export default function NotFound() {
    return (
        <>
            <Seo
                title="Page Not Found"
                description="The page you were looking for could not be found."
                path="/"
                noindex
            />

            <section className="status-page">
                <div>
                    <Reveal y={20}>
                        <p className="status-page__code">404</p>
                    </Reveal>

                    <WordReveal
                        as="h1"
                        className="t-h2 status-page__title"
                        text="This page moved, or never existed."
                    />

                    <Reveal delay={0.14}>
                        <p className="t-lead status-page__lead">
                            Let’s get you back to something we actually built.
                        </p>
                    </Reveal>

                    <Reveal delay={0.2} className="status-page__actions">
                        <Link className="btn btn--accent" to="/">Back to home</Link>
                        <Link className="btn btn--ghost" to="/services">Services</Link>
                        <Link className="btn btn--ghost" to="/portfolio">Portfolio</Link>
                    </Reveal>
                </div>
            </section>
        </>
    );
}
